<template>
  <div class="room-bind-owner-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('roomBindOwner.title')" :subtitle="$t('roomBindOwner.page.subtitle')">
      <template #extra>
        <el-button icon="el-icon-back" @click="_goBack">
          {{ $t('common.back') }}
        </el-button>
        <el-button type="primary" icon="el-icon-check" @click="saveRoomBindOwnerInfo">
          {{ $t('common.submit') }}
        </el-button>
      </template>
    </ds-page-header>

    <!-- (2) 绑定信息表单面板 -->
    <div class="ds-panel ds-panel--padded">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('roomBindOwner.page.infoTitle') }}</span>
      </div>

      <el-form label-width="120px" class="ds-form">
        <el-form-item :label="$t('roomBindOwner.owner')">
          <el-input v-model.trim="roomBindOwnerInfo.ownerName"
            :placeholder="$t('roomBindOwner.ownerPlaceholder')" disabled />
        </el-form-item>

        <el-form-item :label="$t('roomBindOwner.room')">
          <el-row :gutter="16">
            <el-col :span="18">
              <el-input v-model.trim="roomBindOwnerInfo.roomName"
                :placeholder="$t('roomBindOwner.roomPlaceholder')" disabled />
            </el-col>
            <el-col :span="6">
              <el-button type="primary" icon="el-icon-plus" @click="_openChooseRoom">
                {{ $t('listOwner.selectRoom') }}
              </el-button>
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item :label="$t('roomBindOwner.startTime')">
          <el-date-picker v-model="roomBindOwnerInfo.startTime" type="date"
            :placeholder="$t('roomBindOwner.startTimePlaceholder')" value-format="yyyy-MM-dd" class="w-full" />
        </el-form-item>

        <el-form-item :label="$t('roomBindOwner.endTime')">
          <el-date-picker v-model="roomBindOwnerInfo.endTime" type="date"
            :placeholder="$t('roomBindOwner.endTimePlaceholder')" value-format="yyyy-MM-dd" class="w-full" />
        </el-form-item>
      </el-form>
    </div>

    <!-- 表单操作区 -->
    <div class="ds-form-actions">
      <el-button icon="el-icon-back" @click="_goBack">
        {{ $t('common.back') }}
      </el-button>
      <el-button type="primary" icon="el-icon-check" @click="saveRoomBindOwnerInfo">
        {{ $t('common.submit') }}
      </el-button>
    </div>

    <search-room ref="searchRoomRef" :roomFlag="roomFlag" @chooseRoom="handleChooseRoom" />
  </div>
</template>

<script>
import { sellRoom } from '@/api/owner/roomBindOwnerApi'
import { getCommunityId } from '@/api/community/communityApi'
import searchRoom from '@/components/room/searchRoom'
import { getDateYYYYMMDD } from '@/utils/dateUtil'
import { queryOwners } from '@/api/owner/ownerApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'

export default {
  name: 'RoomBindOwnerList',
  components: {
    searchRoom,
    DsPageHeader
  },
  data() {
    return {
      roomFlag: '2',
      roomBindOwnerInfo: {
        roomId: '',
        roomName: '',
        ownerId: '',
        ownerName: '',
        state: '2001',
        startTime: '',
        endTime: '2099-01-01',
      },
      communityId: ''
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.roomBindOwnerInfo.startTime = getDateYYYYMMDD()
    this.initData()
  },
  methods: {
    initData() {
      const ownerId = this.$route.query.ownerId
      if (ownerId) {
        this.roomBindOwnerInfo.ownerId = ownerId
        this.listOwner(ownerId)
      }
    },
    async listOwner(ownerId) {
      try {
        const params = {
          page: 1,
          row: 1,
          memberId: ownerId,
          communityId: this.communityId
        }
        const { data } = await queryOwners(params)
        this.roomBindOwnerInfo.ownerName = data[0].name
      } catch (error) {
        this.$message.error(this.$t('roomBindOwner.fetchRoomError'))
      }
    },
    handleChooseRoom(room) {
      this.roomBindOwnerInfo.roomName = room.roomName
      this.roomBindOwnerInfo.roomId = room.roomId
    },
    _openChooseRoom() {
      this.$refs.searchRoomRef.open()
    },
    _goBack() {
      this.$router.go(-1)
    },
    roomBindOwnerValidate() {
      const rules = {
        ownerId: { required: true, message: this.$t('roomBindOwner.ownerRequired') },
        roomId: { required: true, message: this.$t('roomBindOwner.roomRequired') },
        startTime: { required: true, message: this.$t('roomBindOwner.startTimeRequired') },
        endTime: { required: true, message: this.$t('roomBindOwner.endTimeRequired') }
      }

      const errors = []
      Object.keys(rules).forEach(key => {
        if (!this.roomBindOwnerInfo[key]) {
          errors.push(rules[key].message)
        }
      })

      if (errors.length > 0) {
        this.$message.error(errors[0])
        return false
      }

      const start = new Date(this.roomBindOwnerInfo.startTime)
      const end = new Date(this.roomBindOwnerInfo.endTime)
      if (start >= end) {
        this.$message.error(this.$t('roomBindOwner.timeError'))
        return false
      }

      return true
    },
    async saveRoomBindOwnerInfo() {
      if (!this.roomBindOwnerValidate()) return

      try {
        const data = {
          ...this.roomBindOwnerInfo,
          communityId: this.communityId
        }

        const res = await sellRoom(data)
        if (res.code === 0) {
          this.$message.success(this.$t('common.operationSuccess'))
          this._goBack()
        } else {
          this.$message.error(res.msg || this.$t('common.submitFailed'))
        }
      } catch (error) {
        this.$message.error(this.$t('common.requestError'))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.room-bind-owner-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

/* 白色面板 */
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
  margin-bottom: var(--ds-spacing-lg);

  &--padded {
    padding: var(--ds-spacing-lg);
  }
}

/* 面板标题栏 */
.ds-panel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: var(--ds-spacing-md);
  margin-bottom: var(--ds-spacing-lg);
  border-bottom: 1px solid var(--ds-gray-200);
}

.ds-panel__title {
  font-size: var(--ds-font-size-lg);
  font-weight: 600;
  color: var(--ds-gray-800);
}

/* 表单 */
.ds-form {
  .el-form-item {
    margin-bottom: var(--ds-spacing-lg);
  }
}

/* 表单操作区 */
.ds-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--ds-spacing-sm);
  padding-top: var(--ds-spacing-md);
  border-top: 1px solid var(--ds-gray-200);
}
</style>
